import React, { useState } from 'react';
import { Table } from 'tea-component';
import "./index.scss";
const { pageable, sortable } = Table.addons;
const Sortstable = (porps: any) => {
  const { tableData, className, recordKey = 'id' } = porps;
  const [sorts, setSorts] = useState<any>([]);
  return (
    <Table
      bordered="all"
      className={`dbi-norma-table ${className}`}
      recordKey={recordKey}
      records={[...tableData.cvmList].sort(sortable.comparer(sorts))}
      columns={tableData.columns}
      addons={[
        pageable(),
        sortable({
          columns: ['date'],
          value: sorts,
          onChange: (value) => setSorts(value),
        }),
        tableData?.addons,
      ]}
    />
  );
};

export default Sortstable;
